import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Slider from 'react-slick';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
  leftArrow: {
    position: 'absolute',
    left: -30,
    top: 110,
    zIndex: 10,
    [theme.breakpoints.up('sm')]: {
      top: 150,
    },
    [theme.breakpoints.up('md')]: {
      left: -60,
    },
  },
  rightArrow: {
    position: 'absolute',
    right: -30,
    top: 110,
    zIndex: 10,
    transform: 'rotate(180deg)',
    [theme.breakpoints.up('sm')]: {
      top: 150,
    },
    [theme.breakpoints.up('md')]: {
      right: -40,
    },
  },
  '@global': {
    '.slick-dots': {
      bottom: 15,
      [theme.breakpoints.up('md')]: {
        bottom: 25,
      },
    },
    '.slick-dots li button:before': {
      display: 'none',
    },
    '.slick-dots li button': {
      background: '#fff',
      content: '',
      borderRadius: 20,
      width: 10,
      height: 10,
    },
    '.slick-dots li.slick-active button': {
      background: '#076BD1',
    },
  },
}));

function NextArrow(props) {
  const classes = useStyles();
  const { onClick } = props;
  return (
    <IconButton aria-label="delete" onClick={onClick} className={classes.rightArrow}>
      <ArrowBackIcon />
    </IconButton>
  );
}

function PrevArrow(props) {
  const classes = useStyles();
  const { onClick } = props;
  return (
    <IconButton aria-label="delete" onClick={onClick} className={classes.leftArrow}>
      <ArrowBackIcon />
    </IconButton>
  );
}

const settings = {
  dots: false,
  centerPadding: 0,
  speed: 500,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 2,
  centerMode: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};

const Index = ({ children }) => {
  return children ? <Slider {...settings}>{children}</Slider> : null;
};

Index.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default Index;
